import { Component, Input } from '@angular/core';
import { HeroInfo } from './section-hero.module';

@Component({
  selector: 'app-section-hero',
  templateUrl: './section-hero.component.html',
  styleUrls: ['./section-hero.component.css']
})
export class SectionHeroComponent {
  
  @Input() heroInfo: HeroInfo = {
    backgroundImage: '',
    backgroundPositionY: '',
    backgroundColor: '',
    showTitle: false,
    title: '',
    showSubtitle: false,
    subtitle: '',
    showButton1: false,
    button1Text: '',
    button1Link: '',
    showButton2: false,
    button2Text: '',
    button2Link: ''
  };

}
